import axios from 'axios';
import toast from 'react-hot-toast';
import { useMutation, useQuery, UseQueryOptions } from 'react-query';
import Attachment from '../types/attachment';
import { Note } from '../types/note';
import Stage from '../types/stage';
import StateRecord from '../types/state-record';
import {
  BASE_URL,
  NOTE_URL,
  RECORD_URL,
  REMOVE_ACCESS_URL,
  STAGE_ACCESS_URL,
  STAGE_ATTACHMENT_URL,
  STAGE_URL,
  SUBMIT_URL
} from './urls';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {}
});

apiClient.interceptors.request.use(function (config) {
  if (config.headers) config.headers.authorization = localStorage.getItem('AUTH_TOKEN') ?? '';
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      localStorage.clear()
      // toast.error('نشست کاری شما به اتمام رسید، لطفا دوباره وارد شوید')
      setTimeout(() => { window.location.href = '/login' }
        , 2000)
    }
  })

export const useGetStage = (
  stageId?: string,
  options?: Omit<UseQueryOptions<Stage>, 'querykey'>
) => {
  return useQuery<Stage>(
    'stage-' + stageId,
    async () => {
      const res = await apiClient.get(STAGE_URL + stageId);
      return res.data;
    },
    options
  );
};

export const useGetStageNotes = (
  stageId: string,
  options?: Omit<UseQueryOptions<Note[]>, 'querykey'>
) => {
  return useQuery<Note[]>(
    'notes-' + stageId,
    async () => {
      const res = await apiClient.get(NOTE_URL(stageId));
      return res.data;
    },
    options
  );
};

export const useGetStageRecords = (
  stageId: string,
  options?: Omit<UseQueryOptions<StateRecord[]>, 'querykey'>
) => {
  return useQuery<StateRecord[]>(
    'records-' + stageId,
    async () => {
      const res = await apiClient.get(RECORD_URL(stageId));
      return res.data;
    },
    options
  );
};

export const useGetStageAttachments = (
  stageId: string,
  options?: Omit<UseQueryOptions<Attachment[]>, 'querykey'>
) => {
  return useQuery<Attachment[]>(
    'messages-' + stageId,
    async () => {
      const res = await apiClient.get(STAGE_ATTACHMENT_URL(stageId));
      return res.data;
    },
    options
  );
};

export const useGetStageAccesses = (stageId: string) => {
  return useQuery('stage-accesse-' + stageId, async () => {
    const res = await apiClient.get(STAGE_ACCESS_URL(stageId));
    return res.data;
  });
};

export function useCreateAccess() {
  return useMutation(
    ({
      stageId,
      accounts,
      read,
      write,
    }: {
      stageId: string;
      accounts: string[];
      read: boolean;
      write: boolean;
    }) =>
      apiClient.post(STAGE_ACCESS_URL(stageId), {
        stageId,
        accounts,
        read,
        write,
      })
  );
}

export function useCreateNote(
  stageId: string,
  options?: Omit<UseQueryOptions<Note[]>, 'querykey'>
) {
  return useMutation((content: string) => apiClient.post(NOTE_URL(stageId), { content }));
}

export function useChangeState(
  stageId: string,
  options?: Omit<UseQueryOptions<Note[]>, 'querykey'>
) {
  return useMutation((newState: number) => apiClient.post(SUBMIT_URL(stageId), { newState }));
}
export function useDeleteAccess(
) {
  return useMutation((accessId: string) => apiClient.delete(REMOVE_ACCESS_URL(accessId),));
}
